import React from 'react';
import '../Styles/About.css'

export default function About() {
    return (
        <div>
            <h2>About Me</h2> 
            <p className="about">
            My name is Augustus Madden. I am a recent graduate of Drexel University's Westphal College of Media Arts and Design, having earned a Bachelor's degree in Animation and Visual Effects. I've spent most of my life living in the Philadelphia Area. Hobbies include cooking, working out, and listening to educational podcasts in my downtime.
            </p>
            <p className="about">
            I'm interested in all aspects of content creation, with a current focus on web design work. I have a strong interest in narrative and interactivity, and I'm looking for an opportunity to join a team of professionals interested in creating meaningful, compelling content.
            </p>
        </div>
        
    );
}